function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import noop from 'lodash/noop';
import classNames from 'classnames';
import React from 'react';
import gettext from 'js-utils/gettext';
import { isMediumDown } from '../utils/mediaQueries';
/* Foundational Imports */

import Dropdown from '../containers/dropdown/Dropdown';
import ShareIosChunkySvg from '../iconography/icons/ShareIosChunky';
import HeartFillChunkySvg from '../iconography/icons/HeartFillChunky';
import HeartChunkySvg from '../iconography/icons/HeartChunky';
/* Atomical Imports */

import Card from '../card/Card';
import { STYLE_BRAND, STYLE_DARK } from '../iconButton/constants';
/* Molecular Imports */

import MediaCardContent from '../mediaCardContent/MediaCardContent';
import { GRID_TYPE, STANDARD_STYLE, IMAGE_STYLE_FIXED } from '../mediaCardContent/constants';
import DateThumbnail from '../dateThumbnail/DateThumbnail';
import { TYPE_SIMPLE, TYPE_COMPLEX } from '../modal/constants';
/* Local Imports */

import { SaveModalContent } from './SaveEventModalContent';
import CollectionView from './internal/CollectionView';
import { ShareModalContent } from './ShareEventModalContent';
import FormattedEventName from './FormattedEventName';
import { getEventTimeString, getFormattedPriceString } from './utils';
import { EVENTBRITE, EVENT_CARD_PROPTYPE, FREE_FLAG_TEXT, SOLD_OUT_FLAG_TEXT } from './constants';

var getLocationNode = function getLocationNode(locationInfo) {
  var component;

  if (locationInfo) {
    component = React.createElement("div", {
      className: "card-text--truncated__one"
    }, locationInfo);
  }

  return component;
};

var getFlagInfo = function getFlagInfo(isFree, isSoldOut) {
  var component;

  if (isFree || isSoldOut) {
    component = React.createElement("span", null, isSoldOut ? SOLD_OUT_FLAG_TEXT : FREE_FLAG_TEXT);
  }

  return component;
};
/*
This implementation of the EventCard utilizes data points and structure that
has been vetted and approved through multiple design iterations. This allows
us to keep a unified appearance of what data a user can expect to find on an
EventCard across our platform.

If you have special customizations or other things needed for your implementation
please feel free to roll your own version utilizing MediaCardContent from EDS.
*/


var EventCard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventCard, _React$PureComponent);

  function EventCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EventCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EventCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      shouldRenderAddToCollectionDropdown: false,
      shouldRenderAddToCollectionModal: false
    });

    _defineProperty(_assertThisInitialized(_this), "_onSaveClick", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          onSaveEvent = _this$props.onSaveEvent,
          savedByYou = _this$props.savedByYou,
          isAuthenticated = _this$props.isAuthenticated,
          userCollections = _this$props.userCollections;

      if (!isAuthenticated) {
        _this._handleSaveModalShow();
      } else if (userCollections) {
        if (!savedByYou && onSaveEvent) {
          onSaveEvent(id, !savedByYou);
        }

        _this._handleUserCollectionShow();
      } else if (onSaveEvent) {
        onSaveEvent(id, !savedByYou);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleShareClick", function () {
      var _this$props2 = _this.props,
          eventId = _this$props2.id,
          eventName = _this$props2.name,
          showOverlay = _this$props2.showOverlay,
          shareOptions = _this$props2.shareOptions,
          onWillShareClick = _this$props2.onWillShareClick,
          onDidShareClick = _this$props2.onDidShareClick;

      if (onWillShareClick) {
        onWillShareClick();
      }

      if (shareOptions && showOverlay) {
        var updatedShareOptions = _objectSpread({}, shareOptions, {
          eventId: eventId,
          eventName: eventName,
          onClick: onDidShareClick
        });

        showOverlay('modal', {
          type: TYPE_SIMPLE,
          title: gettext('Share with friends'),
          children: React.createElement(ShareModalContent, {
            shareOptions: updatedShareOptions
          }),

          /* Due to a bug relating to safari, flexbox, and no set
          height causing the modal to not appear, commenting out this
          param until a fix is in place */
          // noMinHeight: true,
          onClose: noop
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleUserCollectionShow", function () {
      var _this$props3 = _this.props,
          userCollections = _this$props3.userCollections,
          onShowAddToCollectionView = _this$props3.onShowAddToCollectionView;

      if (userCollections) {
        var isSmallScreen = isMediumDown();

        if (isSmallScreen) {
          _this._handleRenderModalCollectionView();
        } else {
          _this._renderDropdownCollectionView();
        }

        if (onShowAddToCollectionView) {
          onShowAddToCollectionView();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderDropdownCollectionView", function () {
      _this.setState({
        shouldRenderAddToCollectionDropdown: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleCloseDropdownCollectionView", function () {
      _this.setState({
        shouldRenderAddToCollectionDropdown: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleRenderModalCollectionView", function () {
      _this.setState({
        shouldRenderAddToCollectionModal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleCloseModalCollectionView", function () {
      _this.setState({
        shouldRenderAddToCollectionModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getCollectionViewProps", function () {
      var _this$props4 = _this.props,
          eventId = _this$props4.id,
          userCollections = _this$props4.userCollections,
          eventCollections = _this$props4.eventCollections,
          onAddOrRemoveEventToCollection = _this$props4.onAddOrRemoveEventToCollection,
          onCreateCollection = _this$props4.onCreateCollection,
          savedByYou = _this$props4.savedByYou,
          onSaveEvent = _this$props4.onSaveEvent,
          onShowCreateCollectionView = _this$props4.onShowCreateCollectionView;
      var isSmallScreen = isMediumDown();
      return {
        eventId: eventId,
        userCollections: userCollections,
        eventCollections: eventCollections,
        onAddOrRemoveEventToCollection: onAddOrRemoveEventToCollection,
        onCreateCollection: onCreateCollection,
        savedByYou: savedByYou,
        onSaveEvent: onSaveEvent,
        isSmallScreen: isSmallScreen,
        onShowCreateCollectionView: onShowCreateCollectionView
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_renderModalCollectionView", function () {
      var showOverlay = _this.props.showOverlay;
      var content = React.createElement("div", {
        className: "event-card__collection-modal-body"
      }, React.createElement(CollectionView, _extends({}, _this._getCollectionViewProps(), {
        onCloseDropdown: _this._handleCloseModalCollectionView
      })));
      showOverlay('modal', {
        type: 'simple',
        children: content,
        onClose: _this._handleCloseModalCollectionView
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getAddToCollectionDropdown", function () {
      var shouldRenderAddToCollectionDropdown = _this.state.shouldRenderAddToCollectionDropdown;
      var component = null;

      if (shouldRenderAddToCollectionDropdown) {
        component = React.createElement("div", {
          className: "eds-event-card__collection-dropdown-container"
        }, React.createElement(Dropdown, {
          onClickOutside: _this._handleCloseDropdownCollectionView,
          align: "right"
        }, React.createElement(CollectionView, _extends({}, _this._getCollectionViewProps(), {
          onCloseDropdown: _this._handleCloseDropdownCollectionView
        }))));
      }

      return component;
    });

    return _this;
  }

  _createClass(EventCard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var shouldRenderAddToCollectionModal = this.state.shouldRenderAddToCollectionModal;
      var _this$props5 = this.props,
          eventCollections = _this$props5.eventCollections,
          hideOverlay = _this$props5.hideOverlay;
      var prevEventCollections = prevProps.eventCollections;
      var prevShouldRenderAddToCollectionModal = prevState.shouldRenderAddToCollectionModal;

      if (shouldRenderAddToCollectionModal) {
        /* To ensure that the modal content is properly re-rendered
        when new collections added or state of the collection is changed
        we want re-trigger the render of the modal when it should be visible
         Additionally in order to prevent setState calls from render errors, we
        trigger initial render of the modal here rather than the render method itself. */
        if (!prevShouldRenderAddToCollectionModal || eventCollections.length !== prevEventCollections.length) {
          this._renderModalCollectionView();
        }
      } else if (!shouldRenderAddToCollectionModal && prevShouldRenderAddToCollectionModal) {
        hideOverlay();
      }
    }
  }, {
    key: "_handleSaveModalShow",
    value: function _handleSaveModalShow() {
      var _this$props6 = this.props,
          showOverlay = _this$props6.showOverlay,
          id = _this$props6.id,
          onSaveEvent = _this$props6.onSaveEvent,
          name = _this$props6.name,
          startDate = _this$props6.startDate,
          imageUrl = _this$props6.imageUrl,
          isLazyImage = _this$props6.isLazyImage;

      if (showOverlay) {
        showOverlay('modal', {
          type: TYPE_COMPLEX,
          children: React.createElement(SaveModalContent, {
            onClick: onSaveEvent,
            id: id,
            name: React.createElement(FormattedEventName, {
              eventName: name
            }),
            imageUrl: imageUrl,
            isLazyImage: isLazyImage,
            startDate: startDate
          }),
          onClose: noop
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          edgeColor = _this$props7.edgeColor,
          name = _this$props7.name,
          startDate = _this$props7.startDate,
          startTime = _this$props7.startTime,
          ticketsBy = _this$props7.ticketsBy,
          url = _this$props7.url,
          isFree = _this$props7.isFree,
          isSoldOut = _this$props7.isSoldOut,
          savedByYou = _this$props7.savedByYou,
          style = _this$props7.style,
          type = _this$props7.type,
          imageStyle = _this$props7.imageStyle,
          containerSpacingClasses = _this$props7.containerSpacingClasses,
          excludeDateThumbnail = _this$props7.excludeDateThumbnail,
          onClick = _this$props7.onClick,
          locationInfo = _this$props7.locationInfo,
          minPrice = _this$props7.minPrice,
          shareOptions = _this$props7.shareOptions,
          repeatingInstanceCount = _this$props7.repeatingInstanceCount,
          isNoFollow = _this$props7.isNoFollow,
          isConsumer = _this$props7.isConsumer,
          focused = _this$props7.focused,
          hideSaveButton = _this$props7.hideSaveButton,
          shouldShowIcons = _this$props7.shouldShowIcons,
          imageUrl = _this$props7.imageUrl,
          isLazyImage = _this$props7.isLazyImage,
          hidePriceDescription = _this$props7.hidePriceDescription,
          isTargetBlank = _this$props7.isTargetBlank;
      /* Formatted event data strings and nodes to render as
      subContent on the eventCard */

      var formattedTimeAndDate = getEventTimeString(startDate, startTime, repeatingInstanceCount);
      var formattedLocationNode = getLocationNode(locationInfo);
      var configProps = {};
      /* If DateThumbnail should be rendered */

      if (!excludeDateThumbnail && !isConsumer) {
        configProps = _objectSpread({}, configProps, {
          extraContent: React.createElement(DateThumbnail, {
            date: startDate
          })
        });
      }
      /* Only render the share Icon if the shareOptions are passed through */


      if (shareOptions) {
        configProps = _objectSpread({}, configProps, {
          secondaryIconType: React.createElement(ShareIosChunkySvg, null),
          secondaryIconOnClick: this._handleShareClick,
          secondaryIconTitle: gettext('Share %(eventName)s with your friends.', {
            eventName: name
          })
        });
      }

      var subtitle;
      var subContentOne = formattedTimeAndDate;
      var subContentTwo = formattedLocationNode;
      var subContentThree;

      if (!hidePriceDescription) {
        subContentThree = getFormattedPriceString(minPrice, isFree, ticketsBy);
      }

      if (isConsumer) {
        subtitle = getEventTimeString(startDate, startTime, repeatingInstanceCount);
        subContentOne = formattedLocationNode;
        subContentTwo = undefined;
        subContentThree = undefined;

        if (!hidePriceDescription) {
          subContentTwo = getFormattedPriceString(minPrice, isFree, ticketsBy);
        }
      }

      var saveIconType = null;
      var saveIconStyle = null;
      var saveIconOnClick = null;
      var saveIconTitle = null;

      if (!hideSaveButton) {
        saveIconType = savedByYou ? React.createElement(HeartFillChunkySvg, null) : React.createElement(HeartChunkySvg, null);
        saveIconStyle = savedByYou ? STYLE_BRAND : STYLE_DARK;
        saveIconOnClick = this._onSaveClick;
        saveIconTitle = gettext('Save %(eventName)s to your collection.', {
          eventName: name
        });
      }

      var collectionDropdown = this._getAddToCollectionDropdown();

      var eventCardClassName = classNames({
        'eds-event-card--consumer': isConsumer,

        /* Necessary to add 1 grid unit of padding
        to ensure hover effect occurs as expected */
        'eds-l-pad-all-1': !isConsumer
      });
      /* Necessary to add 1 grid unit of padding
      to ensure hover effect occurs as expected */

      return React.createElement("div", {
        className: eventCardClassName
      }, React.createElement(Card, {
        style: "neutral"
      }, React.createElement(MediaCardContent, _extends({}, configProps, {
        isConsumer: isConsumer,
        style: style,
        type: type,
        imageStyle: imageStyle,
        containerSpacingClasses: containerSpacingClasses,
        isTargetBlank: isTargetBlank || ticketsBy !== EVENTBRITE,
        isNoFollow: isNoFollow,
        onClick: onClick,
        focused: focused,
        title: React.createElement(FormattedEventName, {
          isConsumer: isConsumer,
          eventName: name
        }),
        linkUrl: url,
        flag: getFlagInfo(isFree, isSoldOut),
        flagDark: isSoldOut,
        subtitle: subtitle,
        subContentOne: subContentOne,
        subContentTwo: subContentTwo,
        subContentThree: subContentThree,
        imageUrl: imageUrl,
        isLazyImage: isLazyImage,
        imageAlt: name,
        placeholderBgColor: edgeColor,
        shouldShowIcons: shouldShowIcons,
        primaryIconType: saveIconType,
        primaryIconStyle: saveIconStyle,
        primaryIconOnClick: saveIconOnClick,
        primaryIconTitle: saveIconTitle,
        primaryIconDropdown: collectionDropdown
      }))));
    }
  }]);

  return EventCard;
}(React.PureComponent);

_defineProperty(EventCard, "propTypes", EVENT_CARD_PROPTYPE);

_defineProperty(EventCard, "defaultProps", {
  style: STANDARD_STYLE,
  type: GRID_TYPE,
  imageStyle: IMAGE_STYLE_FIXED,
  isNoFollow: false,
  hideSaveButton: false,
  shouldShowIcons: true,
  isTargetBlank: false
});

export { EventCard as default };